'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceNoParentScroll;
/**
* Direttiva che previene la propagazione dello scroll ai contenitori esterni (padri)
* quando l'elemento attuale in fase di scroll raggiunge gli estremi top o bottom
*
* @example
* <div ice-no-parent-scroll style="overflow-y: scroll"></div>
*
* Il codice originario proviene da:
* @see http://stackoverflow.com/questions/5802467/prevent-scrolling-of-parent-element
*/
function iceNoParentScroll($timeout) {

  var attachFn = function attachFn(element) {
    return element.on('DOMMouseScroll mousewheel', function (ev) {
      var $this = $(this),
          scrollTop = this.scrollTop,
          scrollHeight = this.scrollHeight,
          height = $this.height(),
          delta = ev.originalEvent.wheelDelta,
          up = delta > 0;

      var prevent = function prevent() {
        ev.stopPropagation();
        ev.preventDefault();
        ev.returnValue = false;
        return false;
      };

      if (!up && -delta > scrollHeight - height - scrollTop) {
        // Scrolling down, but this will take us past the bottom.
        $this.scrollTop(scrollHeight);
        return prevent();
      } else if (up && delta > scrollTop) {
        // Scrolling up, but this will take us past the top.
        $this.scrollTop(0);
        return prevent();
      }
    });
  };

  var detachFn = function detachFn(element) {
    element.off('DOMMouseScroll mousewheel');
  };

  return {
    restrict: 'A',
    link: function link(scope, element) {

      //$timeout(function () {
      attachFn(element);
      //},1000);

      scope.$on('$destroy', function () {
        detachFn(element);
      });
    }
  };
}
;


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/iceNoParentScroll.directive.js
// module id = 144
// module chunks = 2